import { render, staticRenderFns } from "./add-collection-panel.vue?vue&type=template&id=2f58f707&scoped=true&"
import script from "./add-collection-panel.vue?vue&type=script&lang=js&"
export * from "./add-collection-panel.vue?vue&type=script&lang=js&"
import style0 from "./add-collection-panel.vue?vue&type=style&index=0&id=2f58f707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f58f707",
  null
  
)

export default component.exports